import React from 'react';
import PropTypes from 'prop-types';
import { TreeSelect } from 'antd';
import './RDTreeSelect.scss';

const RDTreeSelect = ({ treeData, disabled, selectedKeys, handleChange, style }) => (
  <div className="dataset-tree-input">
    <TreeSelect
      data-testid="tree-select"
      disabled={disabled}
      treeData={treeData}
      showCheckedStrategy={TreeSelect.SHOW_PARENT}
      value={selectedKeys}
      onChange={handleChange}
      treeCheckable
      placeholder="All"
      style={style}
    />
  </div>
);

RDTreeSelect.defaultProps = {
  disabled: false,
  selectedKeys: [],
  style: {
    width: '100%',
    maxWidth: 347,
  },
};

RDTreeSelect.propTypes = {
  /** TreeSelect options */
  treeData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  /** Called when select an option */
  handleChange: PropTypes.func.isRequired,
  /** Whether disabled tree */
  disabled: PropTypes.bool,
  /** Current selected options */
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  /** Inline TreeSelect style */
  style: PropTypes.shape({}),
};

export default RDTreeSelect;
